import { injectIntl } from 'react-intl';
import { ArticleBriefs as ArticleBriefsComponent } from './ArticleBriefs.component';

export const ArticleBriefs = injectIntl(ArticleBriefsComponent);
